import { useState } from "react";

export const ModalPortal = ({ renderTrigger, modalProps, children }) => {
  const [open, setOpen] = useState(false);

  const closeModal = () => {
    setOpen(false);
  };

  const triggerProps = {
    onClick: () => setOpen(true),
  };

  const modalContentProps = {
    open,
    closeModal,
  };

  return (
    <>
      {renderTrigger(triggerProps)}
      {open && children(modalContentProps)}
    </>
  );
};
